<div class="table-container" id="invoice" [formGroup]="shipmentForm">
  <div
    *ngIf="
      shipmentForm.get('productCode').value == 'A' || shipmentForm.get('productCode').value == 'B'
    "
    class="row"
    id="invoiceDetails"
    formGroupName="invoiceDetails"
    [formGroup]="shipmentForm">
    <div class="form-control-add col-md-5">
      <div class="row">
        <div class="col-12 col-md-6">
          <label> {{ 'shipment.lineItem.iossNumber' | translate }}: </label>
          <input type="text" class="form-control" formControlName="iossNumber" />
        </div>
        <div class="col-12 col-md-6">
          <label
            [ngClass]="{
              'required-field': shipmentForm.get('invoiceDetails').get('iossNumber').value !== ''
            }">
            {{ 'shipment.lineItem.iossIssuerCountryCode' | translate }}:
          </label>
          <select class="form-control input-cc" formControlName="iossIssuerCountryCode">
            <option value="">
              {{ 'shipment.lineItem.selectCountry' | translate }}
            </option>
            <option *ngFor="let eachListVal of list" [value]="eachListVal.code">
              {{ eachListVal.name }}
            </option>
          </select>
          <app-error-component
            [controlName]="
              shipmentForm.get('invoiceDetails').get('iossIssuerCountryCode')
            "></app-error-component>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <label> {{ 'shipment.lineItem.invoiceReferenceNumber' | translate }}: </label>
          <input type="text" class="form-control" formControlName="invoiceReferenceNumber" />
        </div>
      </div>
    </div>
    <div class="form-control-add col-12 col-md-6">
      <div class="form-group">
        <label class="control-label mr-2">{{
          'shipment.lineItem.additionalParties' | translate
        }}</label>
        <mat-radio-group aria-label="Select an option" formControlName="additionalParties">
          <mat-radio-button color="warn" class="mr-2" value="Yes">Yes</mat-radio-button>
          <mat-radio-button color="warn" class="mr-4" value="No">No</mat-radio-button>
        </mat-radio-group>

        <button
          [style.visibility]="
            shipmentForm.get('invoiceDetails').get('additionalParties')?.value === 'Yes'
              ? 'visible'
              : 'hidden'
          "
          [disabled]="isBothAdded()"
          class="icon-mat-button big-button"
          (click)="openAddPartiesPopup()"
          #tooltip="matTooltip"
          [matTooltip]="getTooltip() | translate"
          mat-raised-button>
          <i class="bi bi-person-fill-add"></i>
        </button>
      </div>

      <div
        *ngIf="shipmentForm.get('invoiceDetails').get('additionalParties')?.value == 'Yes'"
        class="party-container">
        <div class="party-box" *ngFor="let party of additionalPartiesList">
          <div class="party-header">
            <span class="role">
              {{ party.addressType === 'SELLER' ? 'Seller' : 'Buyer' }}
            </span>

            <button
              matTooltip="{{ 'global.delete' | translate }}"
              class="remove-btn icon-mat-button"
              [disabled]="this.shipmentData.status === 'Manifested'"
              (click)="deleteParty(party.address_id)">
              <i class="bi bi-trash"></i>
            </button>
          </div>

          <div class="party-body">
            <div><strong>Contact Person Name:</strong> {{ party.contactPersonName }}</div>
            <div><strong>Company Name:</strong> {{ party.companyName }}</div>
            <div><strong>Country Name:</strong> {{ party.CountryName }}</div>
            <div><strong>City:</strong> {{ party.city }}</div>
            <div *ngIf="party.postalCode"><strong>Postal Code:</strong> {{ party.postalCode }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col-2"></div>
    <div class="col-8 text-end" style="font-size: 10px">
      <p class="font-italic">
        <b>{{ 'shipment.lineItem.uom' | translate }} </b> -
        {{ 'shipment.lineItem.unitOfMeasurement' | translate }},
        <b>{{ 'shipment.lineItem.cc' | translate }} </b> -
        {{ 'shipment.lineItem.commodityCode' | translate }}
      </p>
    </div>
    <div class="col-2 text-end">
      <button
        class="me-1 icon-mat-header"
        (click)="AddNewLineItem()"
        #tooltip="matTooltip"
        [matTooltip]="'shipment.lineItem.createLineItem' | translate"
        mat-raised-button>
        <em class="bi bi-plus"></em>
      </button>
    </div>
  </div>

  <div formGroupName="invoiceDetails">
    <div formArrayName="lineItems">
      <table class="mb-4" aria-describedby="LineData-table" mat-table [dataSource]="LineDataSource">
        <ng-container matColumnDef="lineItemNumber">
          <th id="noOfLineItem" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.lineItem.no' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let index = index" [formGroup]="row">
            <input
              style="display: none"
              class="form-control w-20"
              type="text"
              formControlName="lineItemNumber" />
            <label>{{ index + 1 }}.</label>
          </td>
        </ng-container>

        <ng-container matColumnDef="lineItemDescription">
          <th class="required-field" id="lineItemDescription" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.lineItem.description' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              [matTooltipDisabled]="!getLineFormControlId(i, 'lineItemDescription').errors"
              [matTooltip]="'shipment.lineItem.minimum170Label' | translate"
              [ngStyle]="{
                'border-color': getLineFormControlId(i, 'lineItemDescription').errors
                  ? 'red'
                  : 'grey'
              }"
              class="form-control"
              formControlName="lineItemDescription" />
          </td>
        </ng-container>

        <ng-container matColumnDef="lineItemUnitPrice">
          <th class="required-field" id="lineItemUnitPrice" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.lineItem.unitPrice' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              (input)="setTotalWeight()"
              [matTooltip]="tooltipUnitPriceValue"
              [matTooltipDisabled]="!getLineFormControlId(i, 'lineItemUnitPrice').errors"
              [ngStyle]="{
                'border-color': getLineFormControlId(i, 'lineItemUnitPrice').errors ? 'red' : 'grey'
              }"
              class="form-control input-weight"
              type="text"
              formControlName="lineItemUnitPrice" />
          </td>
        </ng-container>

        <ng-container matColumnDef="lineItemUnitPriceCurrency">
          <th
            class="required-field"
            id="lineItemUnitPriceCurrency"
            [matTooltipDisabled]="!this.mismatchInCurrency"
            [matTooltip]="this.errorMsg"
            mat-header-cell
            *matHeaderCellDef>
            {{ 'shipment.lineItem.currency' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <select
              [ngStyle]="{
                'border-color':
                  getLineFormControlId(i, 'lineItemUnitPriceCurrency').errors || mismatchInCurrency
                    ? 'red'
                    : 'grey'
              }"
              class="form-control"
              type="text"
              formControlName="lineItemUnitPriceCurrency"
              (change)="onCurrencyChange($event.target.value)">
              <option class="option" *ngFor="let currency of currencyValues" [value]="currency">
                {{ currency }}
              </option>
            </select>
          </td>
        </ng-container>
        <ng-container matColumnDef="lineItemQuantity">
          <th class="required-field" id="lineItemQuantity" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.lineItem.quantity' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              (input)="setTotalWeight()"
              [ngStyle]="{
                'border-color': getLineFormControlId(i, 'lineItemQuantity').errors ? 'red' : 'grey'
              }"
              [matTooltip]="'shipment.lineItem.minimumValue1' | translate"
              type="number"
              step="1"
              class="form-control input-weight"
              formControlName="lineItemQuantity" />
          </td>
        </ng-container>

        <ng-container matColumnDef="lineItemQuantityUnitofMeasurement">
          <th
            class="required-field"
            id="lineItemQuantityUnitofMeasurement"
            mat-header-cell
            *matHeaderCellDef>
            {{ 'shipment.lineItem.quantityUOM' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <select
              [ngStyle]="{
                'border-color': getLineFormControlId(i, 'lineItemQuantityUnitofMeasurement').errors
                  ? 'red'
                  : 'grey'
              }"
              class="form-control"
              type="text"
              formControlName="lineItemQuantityUnitofMeasurement">
              <option
                class="option"
                *ngFor="let misurement of lineQuantityMisurements"
                [value]="misurement">
                {{ misurement }}
              </option>
            </select>
          </td>
        </ng-container>
        <ng-container matColumnDef="lineItemExportCommodityCode">
          <th id="lineItemExportCommodityCode" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.lineItem.exportCC' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              class="form-control input-cc"
              type="text"
              formControlName="lineItemExportCommodityCode" />
          </td>
        </ng-container>
        <ng-container matColumnDef="lineItemImportCommodityCode">
          <th id="Currency" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.lineItem.importCC' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              class="form-control input-cc"
              type="text"
              formControlName="lineItemImportCommodityCode" />
          </td>
        </ng-container>
        <ng-container matColumnDef="lineItemPartNumber">
          <th id="PartNumber" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.lineItem.partNumber' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input class="form-control" type="text" formControlName="lineItemPartNumber" />
          </td>
        </ng-container>
        <ng-container matColumnDef="lineItemReference">
          <th id="lineItemReference" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.lineItem.reference' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <select
              class="form-control input-lineItemUnitPriceCurrency"
              type="text"
              formControlName="lineItemReference">
              <option class="option" *ngFor="let lineItemRef of lineItemRefs" [value]="lineItemRef">
                {{ lineItemRef }}
              </option>
            </select>
          </td>
        </ng-container>

        <ng-container matColumnDef="lineItemExportReasonType">
          <th id="UnitPrice" class="required-field" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.lineItem.exportReasonType' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <select
              [ngStyle]="{
                'border-color': getLineFormControlId(i, 'lineItemExportReasonType').errors
                  ? 'red'
                  : 'grey'
              }"
              class="form-control input-cc"
              type="text"
              formControlName="lineItemExportReasonType">
              <option class="option" *ngFor="let reason of lineItemReasonTypes" [value]="reason">
                {{ reason }}
              </option>
            </select>
          </td>
        </ng-container>
        <ng-container matColumnDef="lineItemManufactureCountry">
          <th
            id="lineItemManufactureCountry"
            class="required-field"
            mat-header-cell
            *matHeaderCellDef>
            {{ 'shipment.lineItem.manufactureCtry' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <select class="form-control input-cc" formControlName="lineItemManufactureCountry">
              <option>{{ 'shipment.lineItem.selectCountry' | translate }}</option>
              <option *ngFor="let eachListVal of list" [value]="eachListVal.code">
                {{ eachListVal.name }}
              </option>
            </select>
          </td>
        </ng-container>
        <ng-container matColumnDef="lineItemNetWeight">
          <th class="required-field" id="lineItemNetWeight" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.lineItem.lineItem' | translate }} <br />
            {{ 'shipment.lineItem.net' | translate }} <br />
            {{ 'shipment.lineItem.weight' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              type="number"
              (input)="setTotalWeight()"
              step="any"
              [matTooltipDisabled]="!getLineFormControlId(i, 'lineItemNetWeight').errors"
              [matTooltip]="'shipment.lineItem.minimumValueDecimal1' | translate"
              [ngStyle]="{
                'border-color': getLineFormControlId(i, 'lineItemNetWeight').errors ? 'red' : 'grey'
              }"
              class="form-control input-weight"
              formControlName="lineItemNetWeight" />
          </td>
        </ng-container>
        <ng-container matColumnDef="lineItemGrossWeight">
          <th class="required-field" id="lineItemGrossWeight" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.lineItem.lineItem' | translate }} <br />
            {{ 'shipment.lineItem.gross' | translate }} <br />
            {{ 'shipment.lineItem.weight' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              type="number"
              (input)="setTotalWeight()"
              step="any"
              [matTooltipDisabled]="!getLineFormControlId(i, 'lineItemGrossWeight').errors"
              [matTooltip]="'shipment.lineItem.minimumValueDecimal1' | translate"
              [ngStyle]="{
                'border-color': getLineFormControlId(i, 'lineItemGrossWeight').errors
                  ? 'red'
                  : 'grey'
              }"
              class="form-control input-weight"
              formControlName="lineItemGrossWeight" />
          </td>
        </ng-container>
        <ng-container matColumnDef="Action">
          <th id="action" class="text-center" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.lineItem.action' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index">
            <i
              [matTooltip]="'shipment.lineItem.delete' | translate"
              class="m-1 icon-mat bi bi-trash"
              (click)="DeleteLineItem(pieces, i)"></i>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>

        <tr class="mat-row justify-content-center" *matNoDataRow>
          {{
            'shipment.lineItem.noDataAvailable' | translate
          }}
        </tr>
      </table>
    </div>
    {{ 'shipment.lineItem.totalLineItemGrossWeight' | translate }} : {{ totalGrossWeight }} <br />
    {{ 'shipment.lineItem.totalLineItemNetWeight' | translate }} :{{ totalNetWeight }} <br />
    {{ 'shipment.lineItem.totalLineItemValue' | translate }} :{{ totalLineItemValue }}
  </div>
</div>
